export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            deleting: false,
        }
    },
    computed: {
        resourceName() {
            throw 'Please implement the "resourceName" computed property';
        },
      deleteApiUrl() {
          return `/api/${this.resourceName}/${this.id}`;
      }
    },
    methods: {
        async handleDelete() {
            if (this.deleting) {
                return;
            }

            this.$bvModal.msgBoxConfirm(this.$t('Are you sure to delete this item?'), {
                title: this.$t('Are you sure?'),
                okVariant: 'danger',
                okTitle: this.$t('Yes'),
                cancelTitle: this.$t('No'),
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (!value) {
                    return;
                }

                this.deleting = true;

                this.axios
                    .delete(this.deleteApiUrl)
                    .then(() => {
                        this.$root.$emit(`deleted::${this.resourceName}`, this.id)
                        this.$emit('deleted', this.item || this.value || null);

                        this.afterDelete && this.afterDelete();
                    })
                    .catch(e => e.response || throw e)
                    .finally(() => {
                        this.deleting = false;
                    });
            })
        },
    },
};
